import { render, staticRenderFns } from "./challan-pdf.vue?vue&type=template&id=a533f244&"
import script from "./challan-pdf.vue?vue&type=script&lang=js&"
export * from "./challan-pdf.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports